import { IDigAdProviderScorecardConfig, IDigAdProviderScorecardBillboardConfig } from '../../../../_shared/models/models-index';
import { IMetricType } from '../../../../_shared/enums/enums';


export class DigAdProviderScorecardConfig implements IDigAdProviderScorecardConfig {
    public reportTitle: string;
    public scorecardMetrics: IDigAdProviderScorecardBillboardConfig[];
}
